module.exports = __webpack_public_path__ + "img/concern.6a07d71.webp";